module.exports = __webpack_public_path__ + "static/AppIconOffer-ca8a53dfb94c64d1d0cacf36bdbbbf5a.png";